module.exports = __webpack_public_path__ + "static/media/pyramid.3c8ca355.png";